import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useRef, useCallback } from "react";
import { StyledInput, UploadContainer, UploadButton, styledSystemKeys } from "./uploadVideo.styles";
import { blockDefaultEvent } from "utils/events";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var useUploadVideo = function useUploadVideo(uploadRef, callback, removeHighlight) {
  var onUpload = useCallback(function (e) {
    return callback(e.target.files);
  }, [callback]);
  var onDrag = useCallback(function (e) {
    return blockDefaultEvent(e);
  }, []);
  var onDrop = useCallback(function (e) {
    blockDefaultEvent(e);
    removeHighlight(e);
    if (!uploadRef.current || !uploadRef.current.contains(event.target)) return;
    callback(e.dataTransfer.files);
  }, [removeHighlight, callback, uploadRef]);
  useEffect(function () {
    window.addEventListener("drop", onDrop);
    window.addEventListener("dragover", onDrag);
    return function () {
      var _window, _window2;
      (_window = window) === null || _window === void 0 ? void 0 : _window.removeEventListener("dragover", onDrop);
      (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.removeEventListener("drop", onDrop);
    };
  }, [onDrop, onDrag]);
  return {
    onUpload: onUpload,
    onDrag: onDrag,
    onDrop: onDrop
  };
};
export default function UploadVideo(props) {
  var id = props.id,
    callback = props.callback;
  var uploadRef = useRef();
  var highlight = function highlight(e) {
    blockDefaultEvent(e);
    document.getElementById("drop_zone_video").classList.add("highlighted");
  };
  var removeHighlight = function removeHighlight(e) {
    blockDefaultEvent(e);
    document.getElementById("drop_zone_video").classList.remove("highlighted");
  };
  var _useUploadVideo = useUploadVideo(uploadRef, callback, removeHighlight),
    onUpload = _useUploadVideo.onUpload,
    onDrop = _useUploadVideo.onDrop;
  return /*#__PURE__*/_jsxs(UploadContainer, _objectSpread(_objectSpread({
    id: "drop_zone_video",
    ref: uploadRef,
    onDrop: onDrop,
    onDragEnter: highlight,
    onDragOver: highlight,
    onDragLeave: removeHighlight
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: [/*#__PURE__*/_jsx(StyledInput, {
      type: "file",
      id: id,
      accept: "video/*",
      onChange: onUpload
    }), /*#__PURE__*/_jsxs(UploadButton, {
      role: "button",
      htmlFor: id,
      children: ["Dra in en video eller ", /*#__PURE__*/_jsx("u", {
        children: "bl\xE4ddra"
      })]
    })]
  }));
}